import { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Circle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

// First five minutes: one useful thing to do straight after signing up.
export default function WelcomeChecklist({ user, onNavigate, onFindProject }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/api/ethos/welcome`).then((r) => setS(r.data)).catch(() => {});
  }, [user]);
  if (!user || !s || s.dismissed || ['admin', 'developer'].includes(user.role)) return null;
  const steps = [
    { key: 'project', done: s.has_project, label: 'Find or request your project', cta: 'Find my project', go: onFindProject },
    { key: 'document', done: s.has_document, label: 'Add one document to your vault', cta: 'Open my vault', go: () => onNavigate('project-archive') },
    { key: 'engage', done: s.engaged, label: 'Join one topic room, or invite one buyer', cta: 'Open Buyers\u2019 Group', go: () => { axios.post(`${API}/api/ethos/welcome/engaged`).catch(() => {}); onNavigate('community-landing'); } },
  ];
  const left = steps.filter((x) => !x.done).length;
  if (!left) return null;
  const dismiss = () => { setS({ ...s, dismissed: true }); axios.post(`${API}/api/ethos/welcome/dismissed`).catch(() => {}); };
  return (
    <div className="container mx-auto px-4 mt-4 max-w-6xl" data-testid="welcome-checklist">
      <div className="rounded-xl border bg-card p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <div>
            <p className="font-semibold">Your first three steps on FBC</p>
            <p className="text-xs text-muted-foreground">{3 - left} of 3 done. Each takes a minute.</p>
          </div>
          <button type="button" onClick={dismiss} className="p-1 text-muted-foreground hover:text-foreground" aria-label="Hide" data-testid="welcome-checklist-dismiss"><X className="h-4 w-4" /></button>
        </div>
        <ol className="grid sm:grid-cols-3 gap-2">
          {steps.map((x) => (
            <li key={x.key} className={`rounded-lg border p-3 flex flex-col gap-2 ${x.done ? 'bg-emerald-50/60 dark:bg-emerald-900/10 border-emerald-200' : ''}`} data-testid={`welcome-step-${x.key}`}>
              <span className="flex items-start gap-1.5 text-sm">
                {x.done ? <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> : <Circle className="h-4 w-4 text-muted-foreground shrink-0 mt-0.5" />}
                {x.label}
              </span>
              {!x.done && <Button size="sm" variant="outline" className="self-start h-7 text-xs" onClick={x.go} data-testid={`welcome-step-${x.key}-btn`}>{x.cta}</Button>}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
